import React from "react";
import cn from "clsx";
import { RenderElementProps } from "./FormElement";

export interface SectionTextProps extends RenderElementProps {}
export const cgiConsentTitleStyels = {
  "text-align": "start"
};
export default function SectionHeader({
  id,
  label,
  className,
  display = true
}: SectionTextProps) {
  if (!label) {
    return null;
  }
  return (
    <div
      id={id}
      className={cn("section-text", className)}
      aria-hidden={!display}
    >
      {id === "cgiConsentTitle" ? (
        <p
          className="section-text"
          style={{ textAlign: "start", margin: "12px" }}
        >
          {label}
        </p>
      ) : (
        <p>{label}</p>
      )}
    </div>
  );
}
